export const STAGES = ["preventa", "venta", "postventa", "vendido"];

export const STAGE_META = {
  preventa: { label: "Preventa", color: "#5B52EB", bg: "bg-[#5B52EB]/10", text: "text-[#5B52EB]" },
  venta: { label: "Venta", color: "#5C8EAD", bg: "bg-[#5C8EAD]/10", text: "text-[#3E6B87]" },
  postventa: { label: "Post venta", color: "#FFB74D", bg: "bg-[#FFB74D]/15", text: "text-[#A8690F]" },
  vendido: { label: "Vendido", color: "#3E7D4C", bg: "bg-[#81C784]/15", text: "text-[#3E7D4C]" },
};

export const PROPERTY_TYPE_LABELS = {
  piso: "Piso", casa: "Casa", atico: "Ático", local: "Local", terreno: "Terreno", garaje: "Garaje", otro: "Otro",
};

export const OUTCOME_LABELS = { pending: "Pendiente", done: "Realizada", no_show: "No acudió", interested: "Interesado" };

export const fmtPrice = (n) => (n == null ? "—" : `${Number(n).toLocaleString("es-ES")} €`);

export const stagePct = (p) => (p?.required_total ? Math.round((p.required_done / p.required_total) * 100) : 0);

export const nextStage = (stage) => STAGES[STAGES.indexOf(stage) + 1] || null;
